import { useQuery } from '@apollo/react-hooks';
import { OutageDetailsByCounty } from '../../../__generated__/pge-types';
import { getOutagesByCountyQuery } from '../queries/queries';
import { useEffect } from 'react';
import { useErrorNotification } from '../components/common/error-notification';

export const useGetOutagesByCounty = () => {
  const { data, error, loading, refetch } = useQuery<{
    getOutagesByCounty: OutageDetailsByCounty[];
  }>(getOutagesByCountyQuery);

  const { setErrorNotification } = useErrorNotification();

  useEffect(() => {
    error && setErrorNotification();
  }, [error]);

  return {
    outages: data?.getOutagesByCounty as OutageDetailsByCounty[],
    error,
    loading,
    refetch,
  };
};
